import { call, put, takeLatest, fork, all, delay, } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as CampaignService from './../services/campaignService';
import * as Func from "../helpers/functions";
import { PATHS, SAGA_DELAY_TIMEOUT } from '../constants/Define';
import { dataCampaignSuccess, getCountriesSuccess, getChannelsSuccess, setCampaignDetail, parseExcelSuccess, getPromotionBanksSuccess, 
    setMarkupPromotionConfig, setMarkupPromotionFly, setMarkupBundleMinValue } from './../actions/campaignAction';
import i18n from '../constants/initLng';
import history from '../helpers/history';
import Campaign from "../models/Campaign";
import { parseListRequestParams } from "../utils/commonUtils";
import { campaignAutoTranslateRequest } from '../actions/autoTranslateAction';

function* getListCampaign() {
    yield takeLatest(Types.CAMPAIGN_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const pageSize = action.filters.pageSize ? action.filters.pageSize > 10 ? action.filters.pageSize : undefined : undefined;
        const pageIndex = action.filters.pageIndex ? action.filters.pageIndex > 1 ? action.filters.pageIndex : undefined : undefined;
        const params = {
            ...action.filters,
            pageSize, pageIndex,
        };
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(CampaignService.getCampaigns, params);
        yield put(dataCampaignSuccess(result));
    }, errorHandleCampaign(Types.CAMPAIGN_LIST_FAIL)))
}

function* getCampaignDetail() {
    yield takeLatest(Types.CAMPAIGN_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(CampaignService.getCampaignDetail, action.id);
        yield put(setCampaignDetail(result));
    }, errorHandleCampaign(Types.CAMPAIGN_FAIL)))
}

function* updateCampaignDetail() {
    yield takeLatest(Types.CAMPAIGN_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const newModel = new Campaign(action.campaign);
        yield call(CampaignService.updateCampaign, newModel);
        successHandleCampaign(action, `${i18n.t('notification.updateSuccess')}`, newModel.name);
        
        yield put({ type: Types.CAMPAIGN_UPDATE_SUCCESS });
        
        if (action.campaign.targetLanguage && action.campaign.targetLanguage.length > 0) {
            yield put(campaignAutoTranslateRequest({
                sourceId: newModel.id,
                sourceLanguage: 'vi-VN',
                targetLanguages: action.campaign.targetLanguage
            }));
        } else {
            history.push(PATHS.CAMPAIGN.LIST.path);
            history.go();
        }
    }, errorHandleCampaign(Types.CAMPAIGN_FAIL)))
}

function* createCampaignDetail() {
    yield takeLatest(Types.CAMPAIGN_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const newModel = new Campaign(action.campaign);
        const result = yield call(CampaignService.createCampaign, newModel);
        successHandleCampaign(action, `${i18n.t('notification.createSuccess')}`, newModel.name);
        yield put(setCampaignDetail(result));
        history.push(PATHS.CAMPAIGN.LIST.path);
        history.go();
    }, errorHandleCampaign(Types.CAMPAIGN_FAIL)))
}

function* getCountries() {
    yield takeLatest(Types.CAMPAIGN_LIST_COUNTRIES_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(CampaignService.getCountries);
        yield put(getCountriesSuccess(result));
    }, errorHandleCampaign(Types.CAMPAIGN_LIST_COUNTRIES_FAIL)))
}

function* getChannels() {
    yield takeLatest(Types.CAMPAIGN_LIST_CHANNEL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(CampaignService.getChannels);
        yield put(getChannelsSuccess(result));
    }, errorHandleCampaign(Types.CAMPAIGN_LIST_CHANNEL_FAIL)))
}

function* getPromotionBanks() {
    yield takeLatest(Types.CAMPAIGN_LIST_PROMOTION_BANK_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(CampaignService.getPromotionBanks);
        yield put(getPromotionBanksSuccess(result));
    }, errorHandleCampaign(Types.CAMPAIGN_LIST_PROMOTION_BANK_FAIL)))
}

function* deleteCampaign() {
    yield takeLatest(Types.CAMPAIGN_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const campaign = action.campaign;
        yield call(CampaignService.deleteCampaign, campaign.id);
        successHandleCampaign(action, `${i18n.t('notification.updateSuccess')}`, campaign.name);
        yield delay(SAGA_DELAY_TIMEOUT);
        const params = parseListRequestParams(campaign.filter || {});
        const result = yield call(CampaignService.getCampaigns, params);
        yield put(dataCampaignSuccess(result));
    }, errorHandleCampaign(Types.CAMPAIGN_FAIL)))
}

function* cloneCampaign() {
    yield takeLatest(Types.CAMPAIGN_CLONE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const campaign = action.campaign;
        const result = yield call(CampaignService.cloneCampaign, campaign);
        
        if (result && result.data) {
            successHandleCampaign(action, `${i18n.t('notification.createSuccess')}`, campaign.name);
            history.push(PATHS.CAMPAIGN.DETAIL.path.replace(':id', result.data));
            history.go();
        }
    }, errorHandleCampaign(Types.CAMPAIGN_FAIL)))
}

//martkup
function* getMarkupPromotionConfig() {
    yield takeLatest(Types.GET_MARKUP_PROMOTION_CONFIG_ACTION, Func.sagaWrapper(function* (action) {
        const params = {
            ...action.filters
        };
        const result = yield call(CampaignService.getMarkupPromotionConfig, params);
        yield put(setMarkupPromotionConfig(result));
    }, errorHandleCampaign(Types.CAMPAIGN_FAIL)))
}

function* getMarkupPromotionFly() {
    yield takeLatest(Types.GET_MARKUP_PROMOTION_FLY_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(CampaignService.getMarkupPromotionFly);
        yield put(setMarkupPromotionFly(result));
    }, errorHandleCampaign(Types.CAMPAIGN_FAIL)))
}

function* getMarkupBundleMinValue() {
    yield takeLatest(Types.GET_MARKUP_BUNDLE_MIN_VALUE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(CampaignService.getMarkupBundleMinValue, action.data);
        yield put(setMarkupBundleMinValue(result));
    }, errorHandleCampaign(Types.CAMPAIGN_FAIL)))
}
        
//language
function* createCampaignTranslate() {
    yield takeLatest(Types.CAMPAIGN_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        let params = action.campaign
        params = { ...params, promotionExtended: action.promotionExtended }
        yield call(CampaignService.createCampaignTranslate, params);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.languageName);
        yield put({ type: Types.CAMPAIGN_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.CAMPAIGN_DETAIL_ACTION, id: action.campaign.campaignId });
    }, errorHandleCampaign(Types.CAMPAIGN_FAIL)))
}

function* updateCampaignTranslate() {
    yield takeLatest(Types.CAMPAIGN_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
      let params = action.campaign
        params = { ...params, promotionExtended: action.promotionExtended }
        yield call(CampaignService.updateCampaignTranslate, params);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.languageName);
        yield put({ type: Types.CAMPAIGN_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.CAMPAIGN_DETAIL_ACTION, id: action.campaign.campaignId });
    }, errorHandleCampaign(Types.CAMPAIGN_FAIL)))
}

function* parseExcel() {
    yield takeLatest(Types.CAMPAIGN_PARSE_EXCEL_ACTION, Func.sagaWrapper(function* (action) {
        const formData = new FormData();
        formData.append('file', action.file);
        const result = yield call(CampaignService.parseExcel, formData);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.200'));
        yield put(parseExcelSuccess(result));
    }, errorHandleCampaign(Types.CAMPAIGN_PARSE_EXCEL_FAIL)))
}

function successHandleCampaign(action, message, value) {
    return Func.sagaSuccessMessage({
        action,
        message: message || `${i18n.t('notification.createSuccess')}`,
        description: `${i18n.t('item.campaign.title')} "${value}"`
    })
}

function errorHandleCampaign(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'campaign');
}

export function* campaignSaga() {
    yield all([
        fork(getListCampaign),
        fork(getCountries),
        fork(getChannels),
        fork(getCampaignDetail),
        fork(updateCampaignDetail),
        fork(createCampaignDetail),
        fork(deleteCampaign),
        fork(cloneCampaign),
        fork(parseExcel),
        fork(getMarkupPromotionConfig),
        fork(getMarkupPromotionFly),
        fork(getMarkupBundleMinValue),
        fork(getPromotionBanks),
        fork(createCampaignTranslate),
        fork(updateCampaignTranslate)
    ])
}
